import { getToken } from "@/utils/auth";
import request from "@/utils/request";
import { MessageBox, Message } from "element-ui";
import { productId } from "./config";
import router from "@/router/index";
import axios from "axios";
const qs = require("qs");

// 2026-07-14 重新导出巴西/台湾 API（让 TableView/ButtonList 通过 allApi 找得到）
export * from "./brazil";
export * from "./taiwan";

// const aseanApi = "aseanapi"; //dev调用
// const aseanApi = "https://trade.drcnet.com.cn/prod-api"; //线上替换

const aseanApi = process.env.VUE_APP_BASE_USE_API; //测试替换

const { china, world } = productId;
export function productIdApp() {
  let chJson = {
    quanguoMonth: "TOTAL-M",
    beijing: "BJ",
    tianjin: "TJ",
    hebei: "HB-1",
    shanxi: "SX-1",
    neimenggu: "NMG",
    shanghai: "SH",
    jiangsu: "JS",
    zhejiang: "ZJ",
    anhui: "AH",
    fujian: "FJ",
    jiangxi: "JX",
    shandong: "SD",
    guangdong: "GD",
    guangxi: "GX",
    hainan: "HN-1",
    henan: "HN-2",
    hubei: "HB-2",
    hunan: "HN-3",
    liaoning: "LN",
    jilin: "JL",
    heilongjiang: "HLJ",
    chongqing: "CQ",
    sichuan: "SC",
    guizhou: "GZ",
    yunnan: "YN",
    xizang: "XZ",
    shantxi: "SX-2",
    gansu: "GS",
    qinghai: "QH",
    ningxia: "NX",
    xinjiang: "XJ",
  };
  let tempData = 0;
  let sessions = sessionStorage.getItem("routeName");
  // let sessions = router.currentRoute.query.myk
  //   ? router.currentRoute.query.myk
  //   : "base";
  // //console.log(router.currentRoute.query.myk);
  // let sessions = window.$myk ? window.$myk : "base";
  const routeParam = router.history.current;
  // //console.log(routeParam);
  let ku = router.history.current.path.split("/", 2)[1];
  // //console.log(router.history.current.name);
  // //根据路由设置productID
  //中国
  if (sessions == "chplt" || ku == "chplt") {
    tempData = 3 + "," + chJson[routeParam.name];
    //cptpp
  } else if (sessions == "cptpp" || ku == "cptpp") {
    tempData = 2;
    //rcep
  } else if (sessions == "rcep" || ku == "rcep") {
    tempData = 1;
  } else {
    tempData = 0;
  }
  return tempData;
}

// 获取世界主体
export function getComRtData(params) {
  params.productId = productIdApp();
  return request({
    url: "/selectBox/unAuth/getComRtData",
    method: "get",
    params,
  });
}
// 获取世界伙伴
export function getComPtData(params) {
  return request({
    url: "/selectBox/unAuth/getComPtData",
    method: "get",
    params,
  });
}
// 获取世界商品数据
export function getWorldProduction(params) {
  return request({
    url: "/selectBox/unAuth/getWorldServiceTradeType",
    method: "get",
    params,
  });
}
// 获取年份 贸易类别: S/C 服务贸易/货物贸易
// export function getYears (type='') {
//   return request({
//     url: '/common/getYr?types=' + type,
//     method: 'get'
//   })
// }
// 获取年份及月份
export function getYears() {
  return request({
    url: "/common/yearData",
    method: "get",
    headers: { "api-version": "V2" },
  });
}
// 获取贸易概况出口国
export function getComRt() {
  return request({
    url: `/common/getComRt?productId=${productIdApp()}`,
    method: "get",
  });
}
// 首页接口
export function showHomePage(params) {
  return request({
    url: "/visualization/showHomePage?" + qs.stringify(params),
    method: "get",
  });
}
// 获取贸易概况进口国
export function getComPt() {
  return request({
    url: "/common/getComPt",
    method: "get",
  });
}

// 获取贸易额及同比增长
export function getTradeValue(data) {
  return request({
    url: "/visualization/tradeValue",
    method: "post",
    data,
  });
}
// 获取进出口国top10
export function getTradeTop10(data) {
  return request({
    url: "/visualization/inTrade",
    method: "post",
    data,
  });
}
// 哪些国家进口哪些国家哪些商品
export function getNoroutcommodity(data) {
  return request({
    url: "/visualization/inoroutcommodity",
    method: "post",
    data,
  });
}
// 获取贸易平衡
export function getTradeBalance(data) {
  return request({
    url: "/visualization/tradeBalance",
    method: "post",
    data,
  });
}
// 获取贸易概况数据（世界地图）
export function getTradeStatus(data) {
  return request({
    url: "/visualization/tradeStatus",
    method: "post",
    data,
  });
}
// 获取贸易竞争数据（世界地图）
export function getTradeCompetition(data) {
  return request({
    url: "/visualization/tradeCompetition",
    method: "post",
    data,
  });
}

// 获取某国进出口哪些商品
export function getCommodityStructure(data) {
  return request({
    url: "/visualization/commodityStructure",
    method: "post",
    data,
  });
}
// 获取某国进出口前五商品
export function getCommodity(data) {
  return request({
    url: "/visualization/commodity",
    method: "post",
    data,
    headers: { "api-version": "V2" },
  });
}
// 获取进出口增速最快的前五
export function getSpeedUp(data) {
  return request({
    url: "/visualization/speedUp",
    method: "post",
    data,
    headers: { "api-version": "V2" },
  });
}
// 获取贸易顺逆差前10
export function getTradeAlong(data, type) {
  return request({
    url: "/visualization/tradeAlong?type=" + type,
    method: "post",
    data,
  });
}
// 获取某国进出口哪些商品(B页面)
export function getCommodityStructureB(data) {
  return request({
    url: "/visualization/getCommodityStructureB",
    method: "post",
    data,
  });
}

// 获取某国进出口前五商品(B页面)
export function getCommodityB(data) {
  return request({
    url: "/visualization/commodityB",
    method: "post",
    data,
    headers: { "api-version": "V2" },
  });
}
// 获取进出口增速最快的前五(B页面)
export function getSpeedUpB(data) {
  return request({
    url: "/visualization/speedUpB",
    method: "post",
    data,
    headers: { "api-version": "V2" },
  });
}
// 获取贸易竞争矩形树数据
export function getTradeSituation(data) {
  return request({
    url: "/visualization/tradeSituation",
    method: "post",
    data,
  });
}
// 获取世界商品的进口趋势
export function getTradeTrend(data) {
  return request({
    url: "/visualization/tradeTrend",
    method: "post",
    data,
  });
}
// 获取世界商品进口前十的国家
export function getTradeCountry(data) {
  return request({
    url: "/visualization/tradeCountry",
    method: "post",
    data,
  });
}
// 获取世界商品进口前十的国家
export function getTradeCount(data) {
  return request({
    url: "/visualization/tradeCount",
    method: "post",
    data,
  });
}
// 获取散点图
export function getAndout(data) {
  return request({
    url: "/visualization/tradeIndexAndout",
    method: "post",
    data,
  });
}
// 获取某商品竞争力前十国家
export function getTradeIndex(data) {
  return request({
    url: "/visualization/tradeIndex",
    method: "post",
    data,
  });
}
// 获取某商品竞争力增长率前十国家
export function getTradeIndexSpeed(data) {
  return request({
    url: "/visualization/tradeIndexTop",
    method: "post",
    data,
  });
}
// 获取货物贸易世界年度
export function getWorldTradeYear(data) {
  return request({
    url: `/table/unAuth/worldTradeYear?productId=${productIdApp()}`,
    method: "post",
    data,
  });
}
// 获取货物贸易世界年度
export function getWorldTradeMonth(data) {
  return request({
    url: `/table/unAuth/worldTradeMonth?productId=${productIdApp()}`,
    method: "post",
    data,
  });
}
// 获取方式（中国）
export function getTrademodeList(params) {
  return request({
    url: "/selectBox/unAuth/getTrademodeList?" + qs.stringify(params),
    method: "get",
  });
}
// 获取商品（中国）
export function getHaiGuanGoods(params) {
  return request({
    url: "/selectBox/unAuth/getHaiGuanGoods?" + qs.stringify(params),
    method: "get",
  });
}
// 获取伙伴（中国）
export function getHaiGuanState(params) {
  return request({
    url: "/selectBox/unAuth/getHaiGuanState?" + qs.stringify(params),
    method: "get",
  });
}
// 获取主体（中国）
export function getHaiGuanRegion(params) {
  params.productId = productIdApp();
  return request({
    url: "/selectBox/unAuth/getHaiGuanRegion?" + qs.stringify(params),
    method: "get",
  });
}
// 获取贸易（中国）
export function chinaTradeMonth(data) {
  return request({
    url: `/table/unAuth/chinaTradeMonth?productId=${productIdApp()}`,
    method: "post",
    data,
  });
}
// 获取贸易指数商品及行业（中国）
export function getChinaMonthTradeGoods(params) {
  return request({
    url: "/selectBox/unAuth/getChinaMonthTradeGoods?" + qs.stringify(params),
    method: "get",
  });
}
// 获取贸易指数指标（中国）
export function getIndicatorList(params) {
  return request({
    url: "/selectBox/unAuth/getIndicatorList?" + qs.stringify(params),
    method: "get",
  });
}
// 获取贸易指数（中国）
export function chinaGoodsTradeIndicator(data) {
  return request({
    url: `/table/unAuth/chinaGoodsTradeIndicator?productId=${productIdApp()}`,
    method: "post",
    data,
  });
}
// 获取世界服务贸易
export function worldServiceTradeYear(data) {
  return request({
    url: `/table/unAuth/worldServiceTradeYear?productId=${productIdApp()}`,
    method: "post",
    data,
  });
}
// 添加搜索记录
export function addMykDataSearch(data) {
  return request({
    url: "/common/unAuth/addMykDataSearch",
    method: "post",
    data,
  });
}
// 查询搜索记录
export function selectMykDataSearch(data) {
  let params = {
    itype: data.type,
    userId: data.token,
  };
  return request({
    url:
      `/common/unAuth/selectMykDataSearch/${data.pageSize}/${data.pageNum}?` +
      qs.stringify(params),
    method: "get",
  });
}
// 删除搜索记录
export function deleteMykDataSearch(data) {
  return request({
    url: `/common/unAuth/deleteMykDataSearch?` + qs.stringify(data),
    method: "post",
  });
}

function handleDownloadFile(response, fileName) {
  let _fileName = response.headers["content-disposition"].split("=")[1];
  fileName = fileName || getDateName() || _fileName;
  let type = response.headers["content-type"];
  let extension = _fileName.split(".")[1];
  fileName = fileName + "." + extension;
  let blob = {};
  if (response.config.responseType === "blob") {
    blob = new Blob([response.data], { type });
  } else {
    if (response.data) {
      blob = new Blob(["\uFEFF" + response.data], { type });
    } else {
      blob = new Blob([response.data], { type });
    }
  }
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    let link = document.createElement("a");
    let evt = document.createEvent("HTMLEvents");
    evt.initEvent("click", false, false);
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
}
export function downPicData(type, data, fileName) {
  return new Promise((resolve) => {
    request({
      url: `/exportTable/downPicData?type=${type}`,
      method: "post",
      data: data,
      responseType: "blob",
    }).then((res) => {
      handleDownloadFile(res, fileName);
      resolve();
    });
  });
}

// 表格导出数据-世界货物贸易年度
export function worldTradeYear(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/f/exportTable/unAuth/worldTradeYear?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     request({
  //         url: `/exportTable/unAuth/worldTradeYear?productId=${productIdApp()}`,
  //         method: 'post',
  //         data: data,
  //         responseType: 'blob'
  //     }).then(res => {
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     })
  // }))
}
// 表格导出数据-世界货物贸易月度
export function worldTradeMonth(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/f/exportTable/unAuth/worldTradeMonth?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     request({
  //         url: `/exportTable/unAuth/worldTradeMonth?productId=${productIdApp()}`,
  //         method: 'post',
  //         data: data,
  //         responseType:  ['json', 'blob']
  //     }).then(res => {
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     })
  // }))
}
// 表格导出数据-中国贸易指数
export function exportChinaGoodsTradeIndicator(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/f/exportTable/unAuth/chinaGoodsTradeIndicator?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     request({
  //         url: `/exportTable/unAuth/chinaGoodsTradeIndicator?productId=${productIdApp()}`,
  //         method: 'post',
  //         data: data,
  //         responseType: 'blob'
  //     }).then(res => {
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     })
  // }))
}
// 表格导出数据-世界服务贸易年度
export function exportWorldServiceTradeYear(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/f/exportTable/unAuth/worldServiceTradeYear?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     request({
  //         url: `/exportTable/unAuth/worldServiceTradeYear?productId=${productIdApp()}`,
  //         method: 'post',
  //         data: data,
  //         responseType: 'blob'
  //     }).then(res => {
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     })
  // }))
}

function getDateName() {
  let str = "Data-",
    date = new Date();
  return (
    str +
    date.getFullYear() +
    (date.getMonth() + 1 > 9
      ? date.getMonth() + 1
      : "0" + (date.getMonth() + 1)) +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    date.getHours() +
    date.getMinutes() +
    date.getSeconds()
  );
}
// 表格导出数据-中国货物贸易月度
export function exportChinaTradeMonth(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/f/exportTable/unAuth/chinaTradeMonth?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     request({
  //         url: `/exportTable/unAuth/chinaTradeMonth?productId=${productIdApp()}`,
  //         method: 'post',
  //         data: data,
  //         responseType: 'blob'
  //     }).then(res => {
  //         //console.log(res, fileName)
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     })
  // }))
}
// 根据关键字搜索商品
export function getCmdNameList(params) {
  return request({
    url: "/visualization/getCmdNameList?" + qs.stringify(params),
    method: "get",
  });
}
// 贸易互补
export function complementarity(params) {
  return request({
    url: "/visualization/complementarity",
    method: "post",
    data: params,
    headers: { "api-version": "V2" },
  });
}
// 获取静态页面详情
export function getDetailByItype(itype) {
  return request({
    url: `/common/unAuth/getDetailByItype/${itype}`,
    method: "get",
  });
}
export function goodsChange(params) {
  return request({
    url: "/visualization/goodsChange",
    method: "post",
    data: params,
    headers: { "api-version": "V2" },
  });
}

export function commodityChangeB(params) {
  return request({
    url: "/visualization/commodityChangeB",
    method: "post",
    data: params,
    headers: { "api-version": "V2" },
  });
}
export function speedUpChange(params) {
  return request({
    url: "/visualization/speedUpChange",
    method: "post",
    data: params,
    headers: { "api-version": "V2" },
  });
}
export function speedUpBChange(params) {
  return request({
    url: "/visualization/speedUpBChange",
    method: "post",
    data: params,
    headers: { "api-version": "V2" },
  });
}
// 下载报告
export function downloadReport(param, fileName) {
  return new Promise((resolve) => {
    request({
      url: `/exportTable/unAuth/report`,
      method: "post",
      data: param,
      responseType: "blob",
    }).then((res) => {
      handleDownloadFile(res, fileName);
      resolve();
    });
  });
}
// 获取已发布的中美贸易专报年月
export function getReportTimeInfo(params) {
  return request({
    url: "/visualization/get/catrade/time/info?" + qs.stringify(params),
    method: "get",
  });
}
// 获取对应年月份摩擦专报
export function getCatradeInfo(params) {
  return request({
    url: "/visualization/get/catrade/info?" + qs.stringify(params),
    method: "get",
  });
}

//检查token是否过期
export function checkToken(token) {
  return axios({
    baseURL: "http://gxtrade.drcnet.com.cn",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    // url: loginApi + '/rcepapi/user/verifyToken?token=' + token,
    url: "http://gxtrade.drcnet.com.cn/rcepapi/user/verifyToken?token=" + token,
  });
}

// 获取欧盟主体
export function getComRtData2(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeAseanData/getAseanReporters",
  });
}
// 获取印尼主体
export function getComRtData3(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeIndonesiaData/getIndonesiaReporters",
  });
}
// 获取泰国主体
export function getComRtData4(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeThailandData/getThailandReporters",
  });
}
// 获取菲律宾主体
export function getComRtData5(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradePhilippinesData/getPhilippinesReporters",
  });
}
// 获取日本主体
export function getComRtData6(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeJapanData/getJapanReporters",
  });
}
// 获取韩国主体
export function getComRtData7(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeKoreaData/getKoreaReporters",
  });
}
// 获取马来西亚主体
export function getComRtData8(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMalaysiaData/getMalaysiaReporters",
  });
}
// 获取秘鲁主体
export function getComRtData9(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradePeruData/getPeruReporters",
  });
}
// 获取智力主体
export function getComRtData10(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeChileData/getChileReporters",
  });
}
// 获取新西兰主体
export function getComRtData11(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeNewZealandData/getNewzealandReporters",
  });
}
// 获取加拿大主体
export function getComRtData12(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeCanadaData/getCanadaReporters",
  });
}

// 获取欧盟伙伴
export function getComPtData2(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeAseanData/getAseanPartners",
  });
}
// 获取印尼伙伴
export function getComPtData3(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeIndonesiaData/getIndonesiaPartners",
  });
}
// 获取泰国伙伴
export function getComPtData4(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeThailandData/getThailandPartners",
  });
}
// 获取菲律宾伙伴
export function getComPtData5(params) {
  if (router.history.current.name == "monthly2023") {
    params.flag = true;
  } else if (router.history.current.name == "monthly2024") {
    params.flag = false;
  }
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradePhilippinesData/getPhilippinesPartners",
  });
}
// 获取日本伙伴
export function getComPtData6(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeJapanData/getJapanPartners",
  });
}
// 获取韩国伙伴
export function getComPtData7(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeKoreaData/getKoreaPartners",
  });
}
// 获取马来西亚伙伴
export function getComPtData8(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMalaysiaData/getMalaysiaPartners",
  });
}
// 获取秘鲁伙伴
export function getComPtData9(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradePeruData/getPeruPartners",
  });
}
// 获取智力伙伴
export function getComPtData10(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeChileData/getChilePartners",
  });
}
// 获取新西兰伙伴
export function getComPtData11(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeNewZealandData/getNewzealandPartners",
  });
}
// 获取加拿大伙伴
export function getComPtData12(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeCanadaData/getCanadaPartners",
  });
}
// 获取印尼港口指标
export function getportData(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeIndonesiaData/getIndonesiaPorts",
  });
}
// 获取新西兰港口指标
export function getportData2(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeNewZealandData/getNewzealandPorts",
  });
}

// 获取欧盟商品数据
export function getAseanProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeAseanData/getAseanGoods",
  });
}
// 获取菲律宾商品数据
export function getPhilippinesProduction(params) {
  if (router.history.current.name == "monthly2023") {
    params.flag = true;
  } else if (router.history.current.name == "monthly2024") {
    params.flag = false;
  }
  if (router.history.current.name == "annual2023") {
    params.flag = true;
  } else if (router.history.current.name == "annual2024") {
    params.flag = false;
  }
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradePhilippinesData/getPhilippinesGoods",
  });
}
// 获取泰国商品数据
export function getThailandProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeThailandData/getThailandGoods",
  });
}
// 获取日本商品数据
export function getJapanProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeJapanData/getJapanGoods",
  });
}
// 获取韩国商品数据
export function getKoreaProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeKoreaData/getKoreaGoods",
  });
}
// 获取马来西亚商品数据
export function getMalaysiaProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMalaysiaData/getMalaysiaGoods",
  });
}
// 获取秘鲁商品数据
export function getBiluProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradePeruData/getPeruGoods",
  });
}
// 获取智利商品数据
export function getZhiliProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeChileData/getChileGoods",
  });
}
// 获取新西兰商品数据
export function getXxlProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeNewZealandData/getNewzealandGoods",
  });
}
// 获取加拿大商品数据
export function getJndProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeCanadaData/getCanadaGoods",
  });
}
// 获取印尼商品数据
export function getAseanProduction2(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeIndonesiaData/getIndonesiaGoods",
  });
}

// 东盟-获取年份及月份
export function getYears2(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeAseanData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 印尼-获取年份及月份
export function getYears3(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeIndonesiaData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 泰国-获取年份及月份
export function getYears4(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeThailandData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 菲律宾-获取年份及月份
export function getYears5(timeType, productId = productIdApp()) {
  if (router.history.current.name == "monthly2023") {
    timeType = "M0";
  } else if (router.history.current.name == "monthly2024") {
    timeType = "M1";
  }

  if (router.history.current.name == "annual2023") {
    timeType = "Y0";
  } else if (router.history.current.name == "annual2024") {
    timeType = "Y1";
  }
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradePhilippinesData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 日本-获取年份及月份
export function getYears6(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeJapanData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 韩国-获取年份及月份
export function getYears7(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeKoreaData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 马来西亚-获取年份及月份
export function getYears8(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeMalaysiaData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 秘鲁-获取年份及月份
export function getYears9(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradePeruData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 智力-获取年份及月份
export function getYears10(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeChileData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 新西兰-获取年份及月份
export function getYears11(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeNewZealandData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 加拿大-获取年份及月份
export function getYears12(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeCanadaData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 东盟-table表格数据
export function getWorldTradeYear2(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeAseanData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 印尼-table表格数据
export function getWorldTradeYear3(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeIndonesiaData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 泰国-table表格数据
export function getWorldTradeYear4(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeThailandData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 菲律宾-table表格数据
export function getWorldTradeYear5(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradePhilippinesData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 日本-table表格数据
export function getWorldTradeYear6(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeJapanData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 韩国-table表格数据
export function getWorldTradeYear7(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeKoreaData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 马来西亚-table表格数据
export function getWorldTradeYear8(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMalaysiaData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 秘鲁-table表格数据
export function getWorldTradeYear9(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradePeruData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 智力-table表格数据
export function getWorldTradeYear10(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeChileData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 新西兰-table表格数据
export function getWorldTradeYear11(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeNewZealandData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 加拿大-table表格数据
export function getWorldTradeYear12(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeCanadaData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 表格导出数据-东盟货物贸易年度
export function worldTradeYear2(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeAseanData/aseanTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeAseanData/aseanTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-印尼货物贸易年度
export function worldTradeYear3(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeIndonesiaData/indonesiaTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeIndonesiaData/indonesiaTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-泰国货物贸易年度
export function worldTradeYear4(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeThailandData/thailandTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeThailandData/thailandTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-菲律宾货物贸易年度
export function worldTradeYear5(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradePhilippinesData/philippinesTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradePhilippinesData/philippinesTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-日本货物贸易年度
export function worldTradeYear6(data, fileName) {
  // return request({
  //     baseURL: '/',
  //     headers: {
  //         'api-version': 'V1'
  //     },
  //     url: aseanApi + '/api/tradeJapanData/getTableData?productId=' + productIdApp(),
  //     method: 'post',
  //     data: params
  // })
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeJapanData/japanTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     request({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         url: aseanApi + '/api/tradeJapanData/japanTableDownload?productId=0',

  //         method: 'post',
  //         data: data,
  //         responseType:  ['json', 'blob']
  //     }).then(res => {
  //         //console.log(res, fileName)
  //         handleDownloadFile(res, fileName)
  //         // resolve()
  //     })
  //     // request({
  //     //     url: aseanApi + '/api/tradeJapanData/japanTableDownload?productId=0',

  //     //     method: 'post',
  //     //     data: data,
  //     //     responseType:  ['json', 'blob']
  //     // }).then(res => {
  //     //     //console.log(res, fileName)
  //     //     handleDownloadFile(res, fileName)
  //     //     resolve()
  //     // })
  // }))
}
// 表格导出数据-韩国货物贸易年度
export function worldTradeYear7(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeKoreaData/koreaTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeKoreaData/koreaTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-马来西亚货物贸易年度
export function worldTradeYear8(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMalaysiaData/malaysiaTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeMalaysiaData/malaysiaTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-秘鲁货物贸易年度
export function worldTradeYear9(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradePeruData/peruTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradePeruData/peruTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-智力货物贸易年度
export function worldTradeYear10(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeChileData/chileTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeChileData/chileTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-新西兰货物贸易年度
export function worldTradeYear11(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeNewZealandData/newzealandTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeNewZealandData/newzealandTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}
// 表格导出数据-加拿大货物贸易年度
export function worldTradeYear12(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeCanadaData/canadaTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
  // return new Promise((resolve => {
  //     axios({
  //         baseURL: '/',
  //         headers: {
  //             'api-version': 'V1'
  //         },
  //         data: data,
  //         method: 'POST',
  //         responseType: 'blob',
  //         url: aseanApi + '/api/tradeCanadaData/canadaTableDownload?productId=0',
  //     }).then(res => {
  //         //console.log(res, fileName);
  //         handleDownloadFile(res, fileName)
  //         resolve()
  //     });
  // }))
}

// 获取货物贸易世界年度
export function getOrderDetail() {
  return request({
    url: `/common/orderDetail?productId=${productIdApp()}`,
    method: "get",
  });
}

/**2024-2-19新增国家 */
/**rcep */
/**新加坡 */
// 获取新加坡主体
export function getComRtData13(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeSingaporeData/getSgpReporters",
  });
}
// 表格导出数据-新加坡货物贸易年度
export function worldTradeYear13(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeSingaporeData/sgpTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 新加坡-table表格数据
export function getWorldTradeYear13(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeSingaporeData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 新加坡-获取年份及月份
export function getYears13(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeSingaporeData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取新加坡伙伴
export function getComPtData13(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeSingaporeData/getSgpPartners",
  });
}
// 获取新加坡商品数据
export function getSingaporeProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeSingaporeData/getSgpGoods",
  });
}
/**文莱 */
// 获取文莱主体
export function getComRtData14(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeBruneiData/getBruneiReporters",
  });
}
// 表格导出数据-文莱货物贸易年度
export function worldTradeYear14(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeBruneiData/bruneiTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 文莱-table表格数据
export function getWorldTradeYear14(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeBruneiData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 文莱-获取年份及月份
export function getYears14(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeBruneiData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取文莱伙伴
export function getComPtData14(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeBruneiData/getBruneiPartners",
  });
}
// 获取文莱商品数据
export function getBruneiProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeBruneiData/getBruneiGoods",
  });
}
/**柬埔寨 */
// 获取柬埔寨主体
export function getComRtData15(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeCambodiaData/getCbdReporters",
  });
}
// 表格导出数据-柬埔寨货物贸易年度
export function worldTradeYear15(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeCambodiaData/cbdTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 柬埔寨-table表格数据
export function getWorldTradeYear15(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeCambodiaData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 柬埔寨-获取年份及月份
export function getYears15(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeCambodiaData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取柬埔寨伙伴
export function getComPtData15(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeCambodiaData/getCbdPartners",
  });
}
// 获取柬埔寨商品数据
export function getTradeCambodiaProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeCambodiaData/getCbdGoods",
  });
}
/**老挝 */
// 获取老挝主体
export function getComRtData16(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeLaosData/getLaosReporters",
  });
}
// 表格导出数据-老挝货物贸易年度
export function worldTradeYear16(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeLaosData/laosTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 老挝-table表格数据
export function getWorldTradeYear16(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeLaosData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 老挝-获取年份及月份
export function getYears16(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeLaosData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取老挝伙伴
export function getComPtData16(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeLaosData/getLaosPartners",
  });
}
// 获取老挝商品数据
export function getTradeLaosProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeLaosData/getLaosGoods",
  });
}
/**缅甸 */
// 获取缅甸主体
export function getComRtData17(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMyanmarData/getMyanmarReporters",
  });
}
// 表格导出数据-缅甸货物贸易年度
export function worldTradeYear17(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMyanmarData/myanmarTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 缅甸-table表格数据
export function getWorldTradeYear17(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMyanmarData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 缅甸-获取年份及月份
export function getYears17(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeMyanmarData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取缅甸伙伴
export function getComPtData17(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMyanmarData/getMyanmarPartners",
  });
}
// 获取缅甸商品数据
export function getTradeMyanmarProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMyanmarData/getMyanmarGoods",
  });
}
/**越南 */
// 获取越南主体
export function getComRtData18(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeVietnamData/getVietnamReporters",
  });
}
// 表格导出数据-越南货物贸易年度
export function worldTradeYear18(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeVietnamData/vietnamTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 越南-table表格数据
export function getWorldTradeYear18(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeVietnamData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 越南-获取年份及月份
export function getYears18(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeVietnamData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取越南伙伴
export function getComPtData18(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeVietnamData/getVietnamPartners",
  });
}
// 获取越南商品数据
export function getTradeVietnamProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeVietnamData/getVietnamGoods",
  });
}
/**澳大利亚 */
// // 获取澳大利亚主体
// export function getComRtData19(params) {
//   params.productId = productIdApp();
//   return request({
//     url: "/api/tradeAustraliaData/getAustraliaReporters",
//     method: "get",
//     params,
//   });
// }
export function getComRtData19(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeAustraliaData/getAustraliaReporters",
  });
}
// 表格导出数据-澳大利亚货物贸易年度
export function worldTradeYear19(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeAustraliaData/worldTradeYearExport?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 澳大利亚-table表格数据-年度
export function getWorldTradeYear19(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeAustraliaData/getYearTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 表格导出数据-澳大利亚货物贸易月度
export function worldTradeYear19Month(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeAustraliaData/worldTradeMonthExport?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 澳大利亚-table表格数据-月度
export function getWorldTradeYear19Month(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeAustraliaData/getMonthTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 澳大利亚-获取年份及月份
export function getYears19(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeAustraliaData/yearData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取澳大利亚伙伴
export function getComPtData19(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeAustraliaData/getAustraliaPartners",
  });
}
// 获取澳大利亚商品数据
export function getTradeAustraliaProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeAustraliaData/getWorldServiceTradeType",
  });
}
/**cptpp */
/**文莱 */
/**新加坡 */
/**越南 */
/**澳大利亚 */
/**墨西哥 */

// // 获取墨西哥主体
// export function getComRtData19(params) {
//   params.productId = productIdApp();
//   return request({
//     url: "/api/tradeAustraliaData/getAustraliaReporters",
//     method: "get",
//     params,
//   });
// }
export function getComRtData20(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMexcicoData/getMexcicoReporters",
  });
}
// 表格导出数据-墨西哥货物贸易年度
export function worldTradeYear20(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMexcicoData/worldTradeYearExport?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 墨西哥-table表格数据-年度
export function getWorldTradeYear20(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMexcicoData/getYearTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 表格导出数据-墨西哥货物贸易月度
export function worldTradeYear20Month(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMexcicoData/worldTradeMonthExport?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 墨西哥-table表格数据-月度
export function getWorldTradeYear20Month(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMexcicoData/getMonthTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 墨西哥-获取年份及月份
export function getYears20(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeMexcicoData/yearData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取墨西哥伙伴
export function getComPtData20(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMexcicoData/getMexcicoPartners",
  });
}
// 获取墨西哥商品数据
export function getTradeMexcicoProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMexcicoData/getWorldServiceTradeType",
  });
}
/**英国 */
// // 获取英国主体
export function getComRtData21(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeUKData/getUKReporters",
  });
}
// 表格导出数据-英国货物贸易年度
export function worldTradeYear21(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeUKData/worldTradeYearExport?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 英国-table表格数据-年度
export function getWorldTradeYear21(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeUKData/getYearTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 表格导出数据-英国货物贸易月度
export function worldTradeYear21Month(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeUKData/worldTradeMonthExport?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 英国-table表格数据-月度
export function getWorldTradeYear21Month(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeUKData/getMonthTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 英国-获取年份及月份
export function getYears21(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeUKData/yearData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取英国伙伴
export function getComPtData21(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeUKData/getUKPartners",
  });
}
// 获取英国商品数据
export function getTradeUKProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeUKData/getWorldServiceTradeType",
  });
}

/**澳门 */
// 获取澳门主体
export function getComRtData22(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMacauData/getMacauReporters",
  });
}
// 表格导出数据-澳门货物贸易年度
export function worldTradeYear22(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeMacauData/hkTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 澳门-table表格数据
export function getWorldTradeYear22(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeMacauData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 澳门-获取年份及月份
export function getYears22(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeMacauData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取澳门伙伴
export function getComPtData22(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMacauData/getMacauPartners",
  });
}
// 获取澳门商品数据
export function getTradeMacaoProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeMacauData/getMacauGoods",
  });
}

/**香港 */
// 获取香港主体
export function getComRtData23(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeHKData/getHKReporters",
  });
}
// 表格导出数据-香港货物贸易年度
export function worldTradeYear23(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeHKData/hkTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 香港-table表格数据
export function getWorldTradeYear23(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url: aseanApi + "/api/tradeHKData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 香港-获取年份及月份
export function getYears23(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeHKData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取香港伙伴
export function getComPtData23(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeHKData/getHKPartners",
  });
}
// 获取香港商品数据
export function getTradeHKProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeHKData/getHKGoods",
  });
}

/**欧盟 */
// 获取欧盟主体
export function getComRtData24(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeEuroData/getEuroReporters",
  });
}
// 表格导出数据-欧盟货物贸易年度
export function worldTradeYear24(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeEuroData/euroTableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 欧盟-table表格数据
export function getWorldTradeYear24(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeEuroData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 欧盟-获取年份及月份
export function getYears24(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeEuroData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 欧盟-获取商品所有年份
export function getYearsAllProduction(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url: aseanApi + "/api/tradeEuroData/getHsYearBox?productId=" + productId,
  });
}
// 获取欧盟伙伴
export function getComPtData24(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeEuroData/getEuroPartners",
  });
}
// 获取欧盟商品数据
export function getTradeEUProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeEuroData/getEuroGoods",
  });
}

//rcep,cptpp首页内容-获取国家导航
export function getMenuCountrys(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/TradeHomePageController/getMenuCountrys",
  });
}
//rcep,cptpp首页内容-获取桑基图
export function getSankeyInfo(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/TradeHomePageController/getSankeyInfo",
  });
}
//rcep,cptpp首页内容-中间内容
/**
 * // 首页-获取桑基图中间的词贴数据信息列表(结果返回map，value对照--1:贸易额,2:伙伴数量,3:前十伙伴份额,4:RCEP贸易额,5:RCEP占比,
6:贸易额同比,7:RCEP贸易额同比)
 */
export function getWordInfo(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/TradeHomePageController/getWordInfo",
  });
}
//rcep,cptpp首页内容-折线图，面积图
/**
 * 	获取图的类型--8:rcep柱状图,9:CPTPP柱状图,10:RCEP折线图,11:CPTPP直线图
 */
export function getBarAndLineData(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/TradeHomePageController/getBarAndLineData",
  });
}
//chplt首页桑基图
/**
 *
 */
export function getCHPLTSankeyInfo(params) {
  params.productId = "3";
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/TradeHomePageController/getCHPLTSankeyInfo",
  });
}
/**
 * 
按目的地查询
*/

// 目的地查询-单选
export function getKoreaTargets(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tax/getTargetCountrys",
  });
}

// 数据-税率来源国-多选

export function getKoreaSources(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tax/getSourceCountrys",
  });
}
//数据-税率商品维度查询
export function getKCTaxGoods(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tax/getTaxGoods",
  });
}

// 数据-税率最终表格
export function taxgetTableData(params) {
  const routeParam = router.history.current;
  // //console.log(routeParam.name);
  if (routeParam.name == "sourceArea") {
    params.ifGather = 0;
  } else if (routeParam.name == "goal") {
    params.ifGather = 1;
  }
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url: aseanApi + "/api/tax/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 表格导出数据-税率货物贸易年度
export function exportTaxgetTableData(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url: aseanApi + "/api/tax/tableDataExport?productId=" + productIdApp() + "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    // //console.log(res, fileName);
    handleDownloadFile(res, fileName);
    // resolve()
  });
}

/**2025-8-6新增国家 */
/**基础库 */
/**阿根廷 */
// 获取阿根廷主体
export function getComRtData25(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeArgentinaData/getArgentinaReporters",
  });
}
// 表格导出数据-阿根廷货物贸易年度
export function worldTradeYear25(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeArgentinaData/tableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 阿根廷-table表格数据
export function getWorldTradeYear25(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeArgentinaData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 阿根廷-获取年份及月份
export function getYears25(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeArgentinaData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取阿根廷伙伴
export function getComPtData25(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeArgentinaData/getArgentinaPartners",
  });
}
// 获取阿根廷商品数据
export function getArgentinaProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeArgentinaData/getArgentinaGoods",
  });
}
/**法国 */

// 获取法国商品数据
export function getFranceProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeFranceData/getFranceGoods",
  });
}
// 获取法国主体
export function getComRtData26(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeFranceData/getFranceReporters",
  });
}
// 表格导出数据-法国货物贸易年度
export function worldTradeYear26(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeFranceData/tableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 法国-table表格数据
export function getWorldTradeYear26(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeFranceData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 法国-获取年份及月份
export function getYears26(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeFranceData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取法国伙伴
export function getComPtData26(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeFranceData/getFrancePartners",
  });
}
/**南非 */

// 获取南非商品数据
export function getSounthAfricaProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeSouthAfricaData/getSounthAfricaGoods",
  });
}
// 获取南非主体
export function getComRtData27(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeSouthAfricaData/getSouthAfricaReporters",
  });
}
// 表格导出数据-南非货物贸易年度
export function worldTradeYear27(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeSouthAfricaData/tableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 南非-table表格数据
export function getWorldTradeYear27(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeSouthAfricaData/getTableData?productId=" +
      productIdApp(),
    method: "post",
    data: params,
  });
}
// 南非-获取年份及月份
export function getYears27(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeSouthAfricaData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}
// 获取南非伙伴
export function getComPtData27(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeSouthAfricaData/getSouthAfricaPartners",
  });
}
// 获取南非运输指标
export function getsportsData(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeSouthAfricaData/getSouthAfricaTranSports",
  });
}

/**美国 */

// 获取美国商品数据
export function getUSAProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeUSAData/getUSAGoods",
  });
}
// 获取美国主体
export function getComRtData28(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeUSAData/getUSAReporters",
  });
}
// 表格导出数据-美国货物贸易年度
export function worldTradeYear28(data, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeUSAData/tableDownload?productId=" +
      productIdApp() +
      "",

    method: "post",
    data: data,
    responseType: ["json", "blob"],
  }).then((res) => {
    //console.log(res, fileName);
    handleDownloadFile(res, fileName);
  });
}
// 美国-table表格数据
export function getWorldTradeYear28(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeUSAData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}
// 美国-获取年份及月份
export function getYears28(timeType, index, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeUSAData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType +
      "&index=" +
      index,
  });
}
// 获取美国伙伴
export function getComPtData28(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeUSAData/getUSAPartners",
  });
}
// 获取美国运输指标
export function getRtatesData(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeUSAData/getUSARates",
  });
}
